import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryShowcase() {
  const displayCategories = categories.filter((c) => c.slug !== 'all');

  return (
    <section className="bg-background-100 py-10 md:py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
            漫画分类
          </h2>
          <p className="text-sm text-foreground-500 mt-2">无论你喜欢什么类型，这里都有属于你的韩漫</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-5">
          {displayCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 bg-background-50 rounded-lg border border-background-200 hover:border-primary-300 transition-all duration-200"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <div className="text-center">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900">
                  {cat.name}
                </h3>
                <span className="text-xs text-foreground-500">{cat.count}部作品</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}